import ReactGA from "react-ga"

const enabled = process.env.REACT_APP_ENV === "production"
if (enabled) {
  ReactGA.initialize("UA-163858033-1")
}

export const pageview = () => {
  if (enabled) {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }
}

export const clickedZone = (zone) => {
  if (enabled) {
    ReactGA.event({
      category: "UI",
      action: "Clicked Zone",
      label: `${zone.data.name}`,
    })
  }
}

export const clickedNavigate = (zone) => {
  if (enabled) {
    ReactGA.event({
      category: "UI",
      action: "Clicked Navigate To Zone",
      label: `${zone.data.name}`,
    })
  }
}
